import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const  getEnumerationTypeSelectApi =( async (enumerationType) =>  await http({
    url: ENDPOINTS.enumeration,
    method: 'get',
    params: {
        enumerationType
    }
})
.then((respons) => (respons.data))
)
